import { rootApi } from 'root-api'

const TAG_TYPES = ['REPORT, REPORTS']

const api = rootApi.enhanceEndpoints({ addTagTypes: TAG_TYPES }).injectEndpoints({
  endpoints: (build) => ({
    fetchMeetingsReport: build.query({
      query: ({
        organization,
        currentUserId,
        start,
        end,
        status,
        users = [],
        teams = [],
        groups = [],
        eventTypes = [],
        ...params // additional optional params such as groupBy, sort
      }) => ({
        url: '/api/reports/meetings',
        params: {
          organization,
          currentUserId,
          start,
          end,
          status,
          ...(users?.length > 0 ? { users } : {}),
          ...(teams?.length > 0 ? { teams } : {}),
          ...(groups?.length > 0 ? { groups } : {}),
          ...(eventTypes?.length > 0 ? { eventTypes } : {}),
          ...params
        }
      }),
      extraOptions: {
        handleErrors: false
      },
      providesTags: ['REPORT']
    }),
    fetchMeetingsReports: build.query({
      async queryFn({
        uuids = [],
        organization,
        currentUserId,
        start,
        end,
        status,
        users = [],
        teams = [],
        groups = [],
        eventTypes = [],
        ...params // additional optional params such as groupBy, sort
      }, _queryApi, _extraOptions, fetchWithBQ) {
        const results = uuids.reduce((acc, uuid) => ({
          ...acc,
          [uuid]: fetchWithBQ({
            url: '/api/reports/meetings',
            params: {
              organization,
              currentUserId,
              start,
              end,
              status,
              users: users.filter((user) => user.includes(uuid)),
              teams: teams.filter((team) => team.includes(uuid)),
              groups: groups.filter((group) => group.includes(uuid)),
              eventTypes: eventTypes.filter((eventType) => eventType.includes(uuid)),
              ...params
            }
          })
        }), {})

        const data = await Promise.all(Object.values(results)).then((values) => (values))
        const error = data.find((d) => d.error)

        return error ? { error } : { data }
      },
      extraOptions: {
        handleErrors: false
      },
      providesTags: ['REPORTS']
    }),
    fetchCancelledEventsReport: build.query({
      query: ({
        organization,
        currentUserId,
        start,
        end,
        users = [],
        teams = [],
        groups = [],
        eventTypes = [],
        ...params // additional optional params such as groupBy, sort
      }) => ({
        url: '/api/reports/events/cancelled',
        params: {
          organization,
          currentUserId,
          start,
          end,
          ...(users?.length > 0 ? { users } : {}),
          ...(teams?.length > 0 ? { teams } : {}),
          ...(groups?.length > 0 ? { groups } : {}),
          ...(eventTypes?.length > 0 ? { eventTypes } : {}),
          ...params
        }
      }),
      extraOptions: {
        handleErrors: false
      },
      providesTags: ['REPORT']
    }),
    fetchRescheduledEventsReport: build.query({
      query: ({
        organization,
        currentUserId,
        start,
        end,
        users = [],
        teams = [],
        groups = [],
        eventTypes = [],
        ...params // additional optional params such as groupBy, sort
      }) => ({
        url: '/api/reports/events/rescheduled',
        params: {
          organization,
          currentUserId,
          start,
          end,
          ...(users?.length > 0 ? { users } : {}),
          ...(teams?.length > 0 ? { teams } : {}),
          ...(groups?.length > 0 ? { groups } : {}),
          ...(eventTypes?.length > 0 ? { eventTypes } : {}),
          ...params
        }
      }),
      extraOptions: {
        handleErrors: false
      },
      providesTags: ['REPORT']
    }),
  })
})

export const {
  useFetchMeetingsReportQuery,
  useFetchMeetingsReportsQuery,
  useFetchCancelledEventsReportQuery,
  useFetchRescheduledEventsReportQuery
} = api
export const useFetchMeetingsReportQueryStateResult = (arg, options) => api.endpoints.fetchMeetingsReport.useQueryState(arg, options)
